import { render } from "./ProductCatalogue.vue?vue&type=template&id=279bfc8f&scoped=true"
const script = {}

import "./ProductCatalogue.vue?vue&type=style&index=0&id=279bfc8f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279bfc8f"]])

export default __exports__